var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"componente",class:_vm.fondo,style:({width: _vm.width, height:_vm.heigth, position: _vm.position, top:_vm.top, left:_vm.left })},[_c('span',[_vm._v(_vm._s(_vm.roundToX(_vm.valor))+" "+_vm._s(_vm.unidad))])])
}
var staticRenderFns = []

export { render, staticRenderFns }